export const channels = [
    {
      name: "Sony Kal",
      url: "https://spt-sonykal-1-us.lg.wurl.tv/playlist.m3u8",
      logo: "https://i.ibb.co/8Xq5NgM/20240804-145843.png",
      category: "Entertainment",
    },
    {
      name: "Aaj Tak",
      url: "https://aajtaklive-amd.akamaized.net/hls/live/2014416/aajtak/aajtaklive/live_404p/chunks.m3u8",
      logo: "https://akm-img-a-in.tosshub.com/aajtak/resource/img/aajtak-logo-153X116-v2.png",
      category: "News",
    },
    {
      name: "GNP",
      url: "https://tezlive-amd.akamaized.net/hls/live/2016145/gnt/gntlive/live_404p/chunks.m3u8",
      logo: "https://akm-img-a-in.tosshub.com/aajtak/resource/img/gnttv-logo.png",
      category: "News",
    },
    {
      name: "India Today",
      url: "https://indiatodaylive.akamaized.net/hls/live/2014320/indiatoday/indiatodaylive/live_404p/chunks.m3u8",
      logo: "https://akm-img-a-in.tosshub.com/aajtak/resource/img/at-tab-it.png?imbypass=1",
      category: "News",
    },
    {
      name: "CNBC Awaaz",
      url: "https://nw18live.cdn.jio.com/bpk-tv/CNBC_Awaaz_NW18_MOB/output01/CNBC_Awaaz_NW18_MOB-audio_98834_hin=98800-video=3724000.m3u8",
      logo: "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Ftse1.mm.bing.net%2Fth%3Fid%3DOIP.tfa6vtQ4sKJTpjYuLcOaigHaHx%26pid%3DApi&f=1&ipt=53e2a559114ae7b2eb09f9bcd2d21117e9241b5b4666ded38eee0d84c88ef1b9&ipo=images",
      category: "News",
    },
    {
      name: "CNBC TV18",
      url: "https://nw18live.cdn.jio.com/bpk-tv/CNBC_TV18_NW18_MOB/output01/CNBC_TV18_NW18_MOB-audio_98834_eng=98800-video=2293600.m3u8",
      logo: "https://www.cnbctv18.com/static/images/common/cnbctv18-logo.png",
      category: "News",
    },
    {
      name: "Zee Business",
      url: "https://dwby15d04agvq.cloudfront.net/index_5.m3u8",
      logo: "https://cdn.zeebiz.com/html/images/zee-business.png",
      category: "News",
    },
    {
      name: "Bloomberg",
      url: "https://live-manifest.production-public.tubi.io/live/612b2a65-198f-4a47-8c53-cf85890fa3ef/playlist.m3u8",
      logo: "https://external-content.duckduckgo.com/iu/?u=https%3A%2F%2Fpluspng.com%2Fimg-png%2Fbloomberg-logo-png-bloomberg-l-p-about-careers-products-contacts-1200x630.png&f=1&nofb=1&ipt=8bdc835f8783ccea5dff7f530f22d2884b9fa0ef0d5f503273c085f57039975b&ipo=images",
      category: "News",
    },
    {
      name: "Court TV",
      url: "https://live-manifest.production-public.tubi.io/live/2e06aee5-62c7-47c3-8a38-a2ac5e32fc63/playlist.m3u8",
      logo: "https://canvas-lb.tubitv.com/opts/B26Ze5MjXcdNuw==/c2033d61-8138-4bed-abdc-9e512b797080/CHgQeDoFMS4xLjZAAQ==",
      category: "Entertainment",
    },
    {
      name: "BBC Earth",
      url: "https://live-manifest.production-public.tubi.io/live/01404def-10a0-46f6-9e01-4919814910c0/playlist.m3u8",
      logo: "https://canvas-lb.tubitv.com/opts/TGE1ln0I_gLSwg==/630f09e9-a354-4d28-a952-2f5c75e09815/CHgQeDoFMS4xLjZAAQ==",
      category: "Entertainment",
    },
    {
      name: "Total Crime",
      url: "https://live-manifest.production-public.tubi.io/live/b6dcdce4-fe00-4d30-ae78-73a82bf47e97/playlist.m3u8",
      logo: "https://canvas-lb.tubitv.com/opts/-Xs5E9EjoCF-qQ==/7e8b8518-8447-4c08-9193-55efa2fff3bc/CHgQeDoFMS4xLjZAAQ==",
      category: "Entertainment",
    },
    {
      name: "Cold Case Files",
      url: "https://live-manifest.production-public.tubi.io/live/dadf0b24-f83b-4c68-b4e4-64fdfd982ce3/playlist.m3u8",
      logo: "https://canvas-lb.tubitv.com/opts/LoQHCkJgY7ZjvA==/1741bc33-42d6-4044-8584-c7875bba243c/CHgQeDoFMS4xLjZAAQ==",
      category: "Entertainment",
    },
    {
      name: "World's Most Evil Killers",
      url: "https://live-manifest.production-public.tubi.io/live/b81250ad-f476-4a4b-a824-731dbd24b993/playlist.m3u8",
      logo: "https://canvas-lb.tubitv.com/opts/YnNDuixBnH_Owg==/0aa317c5-3f1c-4949-9e48-3f257c8293c4/CHgQeDoFMS4xLjZAAQ==",
      category: "Entertainment",
    },
    {
      name: "Dateline 24/7",
      url: "https://live-manifest.production-public.tubi.io/live/37e25cb0-d392-4ddb-bb7c-d1629a30d25e/playlist.m3u8",
      logo: "https://canvas-lb.tubitv.com/opts/ug8TYv8KIllPfg==/32d8bd46-4cc6-4f9b-8db3-694be23ed0e3/CHgQeDoFMS4xLjZAAQ==",
      category: "Entertainment",
    },
    {
      name: "Crime ThrillHer",
      url: "https://live-manifest.production-public.tubi.io/live/a3aa485e-32ce-4712-b802-d10c241b673d/playlist.m3u8",
      logo: "https://canvas-lb.tubitv.com/opts/3M057Z1DepNV0w==/d7ddae61-7cf0-40ce-ab9d-2a8bfc8b108b/CHgQeDoFMS4xLjZAAQ==",
      category: "Entertainment",
    },
    {
      name: "News18 India",
      url: "https://nw18live.cdn.jio.com/bpk-tv/News18_India_NW18_MOB/output01/News18_India_NW18_MOB-audio_98835_eng=98800-video=3724000.m3u8",
      logo: "https://images.news18.com/ibnlive/uploads/2022/07/news18-india-165900038616x9.jpg",
      category: "News",
    },
    {
      name: "CNN News18",
      url: "https://nw18live.cdn.jio.com/bpk-tv/CNN_News18_NW18_MOB/output01/CNN_News18_NW18_MOB-audio_98835_hin=98800-video=3724000.m3u8",
      logo: "https://www.medianews4u.com/wp-content/uploads/2018/02/CNN-News-18-logo-2-2.jpg",
      category: "News",
    },
    {
      name: "History TV18 - Hindi",
      url: "https://jmp2.uk/sam-IN1600009NL.m3u8",
      logo: "https://tvpnlogopus.samsungcloud.tv/platform/image/sourcelogo/vc/00/02/34/IN1600009NL_20240813T052445SQUARE.png",
      category: "Entertainment",
    },
    {
      name: "History TV18",
      url: "https://jmp2.uk/sam-IN1600008DN.m3u8",
      logo: "https://tvpnlogopus.samsungcloud.tv/platform/image/sourcelogo/vc/00/02/34/IN1600008DN_20240731T012446SQUARE.png",
      category: "Entertainment",
    },
    {
      name: "TV9 Kannada",
      url: "https://jmp2.uk/sam-INBD2500003XT.m3u8",
      logo: "https://tvpnlogopus.samsungcloud.tv/platform/image/sourcelogo/vc/00/02/34/INBD2500003XT_20240131T032529SQUARE.png_20240131032530.png",
      category: "News",
    },
    {
      name: "News18 Kannada",
      url: "https://jmp2.uk/sam-INBD2500012V1.m3u8",
      logo: "https://tvpnlogopus.samsungcloud.tv/platform/image/sourcelogo/vc/00/02/34/INBD2500012V1_20240131T032509SQUARE.png_20240131032510.png",
      category: "News",
    },
    {
      name: "Republic Kannada",
      url: "https://jmp2.uk/sam-IN1600006GA.m3u8",
      logo: "https://tvpnlogopus.samsungcloud.tv/platform/image/sourcelogo/vc/00/02/34/IN1600006GA_20240612T015020SQUARE.png",
      category: "News",
    },
    {
      name: "Sky News",
      url: "https://jmp2.uk/sam-USBB52000022Q.m3u8",
      logo: "https://tvpnlogopus.samsungcloud.tv/platform/image/sourcelogo/vc/00/02/34/USBB52000022Q_20240520T223417SQUARE.png",
      category: "News",
    },
    {
      name: "Documentary+",
      url: "https://jmp2.uk/sam-USAJ3504701A.m3u8",
      logo: "https://tvpnlogopus.samsungcloud.tv/platform/image/sourcelogo/vc/00/02/34/USAJ3504701A_20240730T222515SQUARE.png",
      category: "Entertainment",
    },
    {
      name: "Xplore",
      url: "https://jmp2.uk/sam-USBC2100008DP.m3u8",
      logo: "https://tvpnlogopus.samsungcloud.tv/platform/image/sourcelogo/vc/00/02/34/USBC2100008DP_20240520T214902SQUARE.png",
      category: "Entertainment",
    },
      {
      name: "Sansad TV",
      url: "https://hls.media.nic.in/hls/live/lstv/lstv.m3u8",
      logo: "https://sansadtv.nic.in/wp-content/uploads/2022/07/logo-sansad.png",
      category: "News",
    },
      {
      name: "WION",
      url: "https://d7x8z4yuq42qn.cloudfront.net/index_1.m3u8",
      logo: "https://img-cdn.thepublive.com/fit-in/360x280/filters:format(webp)/wion/media/agency_attachments/2024/12/13/2024-12-13t071548098z-wionlogo.webp",
      category: "News",
    },
  ];
